import { render, staticRenderFns } from "./-Project.vue?vue&type=template&id=31a861ed&scoped=true&"
import script from "./-Project.vue?vue&type=script&lang=js&"
export * from "./-Project.vue?vue&type=script&lang=js&"
import style0 from "./-Project.vue?vue&type=style&index=0&id=31a861ed&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a861ed",
  null
  
)

export default component.exports